import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";

const BrandAnalyticsPage = lazy(
  () => import("../../pages/faire/BrandAnalyticsPage")
);
const BrandShopPage2Page = withCompass(
  () => import("../../pages/BrandShopPage2Page")
);
const MessagesPage = lazy(() => import("../../pages/faire/MessagesPage"));
const ProductsPage = lazy(() => import("../../pages/faire/ProductsPage"));

export function MartinSitarRoutes() {
  return (
    <Switch>
      <Route path="/ms/faire/products" component={ProductsPage} />
      <Route path="/ms/faire/analytics" component={BrandAnalyticsPage} />
      <Route path="/ms/faire/messages" component={MessagesPage} />
      <Route path="/ms/brand-shop-page-2" component={BrandShopPage2Page} />
    </Switch>
  );
}

export const slug = "ms";
